import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import { useAuth } from '@/features/auth/components/AuthContext';

/**
 * Help entry point for the shared header (TopBar). Renders on every authenticated
 * screen. TVTool B7a (spec §9, D10): the question mark opens the full Help screen
 * (/help — "Ask us" on top, the training videos below) instead of the in-place
 * voice-help card popup; the card itself lives on that screen, unchanged. Hidden
 * when no farmer is logged in (Help attribution requires a session).
 */
export const HelpButton = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!user?.id) return null;

  return (
    <button
      type="button"
      onClick={() => { if (location.pathname !== '/help') navigate('/help'); }}
      aria-label={t('help.title', 'Help')}
      title={t('help.title', 'Help')}
      className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-white/10 active:scale-95 transition-all"
      data-testid="help-button"
    >
      <HelpCircle className="w-6 h-6 text-white" />
    </button>
  );
};
